// текст ошибок валидации полей форм
export const requiredText = 'обязательное поле';
export const requiredRussianText =
  'должно содержать только кириллицу, тире и пробел';
export const invalidFIOText =
  'должно содержать только кириллицу, тире и пробел';
export const invalidNicknameText =
  'должно содержать только кириллицу и латиницу';
export const minPasswordLengthText = 'минимальная длина пароля 8 символов';
export const passwordMismatchText = 'пароли не совпадают';
export const invalidEmailFormatText = 'неверный формат email';
export const invalidPhoneNumberFormatText = 'неверный формат телефона';
export const invalidCommonPhoneNumberFormatText =
  'неверный формат, убедитесь что номер начинается с 8, +380 или +7 и не содержит пробелов и других символов';
export const invalidUrlText = 'неверный формат ссылки';
export const invalidSocialUrlText =
  'должно быть ссылкой или начинаться с символа @';
export const notOnlySpacesText = 'не должно содержать только пробелы';
export const fourRequiredDigitsText = 'должно содержать 4 цифры';
export const sixRequiredDigitsText = 'должно содержать 6 цифр';
export const departmentCodeMaskText = 'должно быть в формате ххх-ххх';
export const duplicatedEmailText =
  'пользователь с таким email уже зарегистрирован';
export const duplicatedPhoneText =
  'пользователь с таким номером телефона уже зарегистрирован';
export const duplicatedQuizTeam =
  'команда с таким названием уже зарегистрирована другим участником';
export const duplicatedNicknameText =
  'пользователь с таким никнеймом уже существует';
export const supportedPhoneFormatText =
  'поддерживаются только номера формата: +7 (9..) ...';
export const invalidPollServerError =
  'Ваш браузер присылает нам неполный ответ. Попробуйте ещё раз или обратитесь в поддержку';
export const duplicatedNicknameServerError = 'that nickname already exists!';
export const duplicatedPhoneServerError = 'duplicated phone';
export const duplicatedEmailServerError = 'duplicated email';

export const invalidEmailServerError = 'invalid email';
export const supportedPhoneFormatServerError =
  'only +7 (9..)-... phones allowed';
export const under18YearsOldText = 'менее 18 лет';
export const addressWithoutHomeNumber = 'Добавьте номер дома';
export const FIOPattern = /^[\u0400-\u04FF\-\s]+$/;
export const RussianRegExp = /^[^А-яЁё ]+$/;
export const UkraineLetters = /[ієїґ\']+/gi;

export const NicknamePattern = /^[\u0400-\u04FFa-zA-Z0-9]+$/;
export const EmailPattern =
  /^([A-Z0-9._%+-]+[a-zA-Z0-9])@[A-Z0-9-]+((\.[A-Z])?\.[A-Z]{2,4})+$/i;
export const UrlPattern =
  /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:\/?#[\]@!\$&'\(\)\*\+,;=.]+$/i;

export const privacyPolicyDocUrl =
  'https://roz-events.storage.yandexcloud.net/media/documents/privacy_policy.pdf';
export const userAgreementDocUrl =
  'https://roz-events.storage.yandexcloud.net/media/documents/user_agreement.pdf';
export const rozInviteRulesDocUrl =
  'https://roz-events.storage.yandexcloud.net/media/documents/roz_invite_rules.pdf';
export const lecturesLeagueRulesDocUrl =
  'https://roz-events.storage.yandexcloud.net/media/documents/Пр_112_22_Приказ_об_утверждении_Положения_об_организации_и_проведении.pdf';

export const breadcrumbs: { [index: string]: any } = {
  collections: 'Коллекции',
};

export enum EAccountUrlBeginnings {
  VK = 'vk',
  HTTPS = 'https://',
  TG = 't.me/',
  AT = '@',
}

// слаг подборки, контент которой ограничен для просмотра для
// неавторизованных и незарегистрированных пользователей
export const RESTRICTED_COLLECTION_CONTENT_SLUG = 'luchshee-ot-znaniya';

export const LZ_SCHOOL_PROJECT_SLUG = 'liga-znaniy-shkolniki';
export const LZ_OPEN_GAMES_PROJECT_SLUG = 'liga-znaniy-igry';

export enum EStorageKeys {
  ALREADY_WATCHED = 'already_watched',
  CINEMA_WELCOME_SHOWN = 'cinema_welcome_shown',
}
